import styled from 'styled-components'

export const Wrapper = styled.div`
  padding-bottom: 18px;
`

export const Subtitle = styled.div`
  padding: 6px 0 4px;
  color: #757575;
  font-weight: bold;
`
